import { render } from "./PedidoMinimo.vue?vue&type=template&id=f77e64fa"
import script from "./PedidoMinimo.vue?vue&type=script&lang=js"
export * from "./PedidoMinimo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__